"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomColumnFormatter = void 0;
const tslib_1 = require("tslib");
/* eslint-disable react/display-name */
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const react_1 = tslib_1.__importDefault(require("react"));
const SortableHeaderFormatter_1 = require("../../dataGrid/headerFormatters/SortableHeaderFormatter");
const TypedDataGridInterfaces_1 = require("../../dataGrid/TypedDataGridInterfaces");
const useRenderLabels_1 = require("../hook/useRenderLabels");
const Styles_1 = require("../Styles");
function createCustomColumnFormatter({ getPropsFromRowData, overrides }) {
    return (Object.assign({ name: 'label-custom', dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey, headerText: catalog_messages_1.Messages.LabelActionSubmenu(), resizable: false, sortable: false, growToFit: true, headerFormatter: createCustomHeaderFormatter(), cellFormatter: createCustomCellFormatter({ getPropsFromRowData }) }, overrides));
}
exports.createCustomColumnFormatter = createCustomColumnFormatter;
function createCustomHeaderFormatter() {
    const sortParams = {};
    return (0, SortableHeaderFormatter_1.createSortableHeaderFormatter)(sortParams);
}
function createCustomCellFormatter({ getPropsFromRowData }) {
    return (cellFormatterProps) => {
        const props = getPropsFromRowData(cellFormatterProps.row.data);
        return react_1.default.createElement(CustomCellFormatter, Object.assign({}, props));
    };
}
function CustomCellFormatter(props) {
    var _a;
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const labels = (0, useRenderLabels_1.useRenderLabels)(Object.assign({ displayCategories: { sensitivity: true, custom: true }, chipDisplayCount: 1, controls: {
            kind: 'chip',
            siteUrls: (props.controls && 'siteUrls' in props.controls) ? (_a = props.controls) === null || _a === void 0 ? void 0 : _a.siteUrls : siteUrls,
        } }, props));
    return (react_1.default.createElement(Styles_1.ChipCellWrapper, null, labels));
}
//# sourceMappingURL=CustomColumnFormatter.js.map